// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__C_yTP","disabled":"FileBtn_disabled__3Lcio","warn":"FileBtn_warn__2RxXr","fade":"FileBtn_fade__2TDBA"};